import { ROLES as R } from "../core/roles";
import { lud, rule } from "../core/rule";

export const faultPermissions = { view: "fault.view" };

// Faults is a branch-user page: the `branch` role reaches it (its assigned branches
// limit the data) and only with at least one valid assigned branch (NA-035). Staff and clients listed here reach it as well.
// A `new` client does not hold it: the same permission guards filing an objection (POST /objection), an operational action, and a store
// that has no operating branch has no faults to read. It is locked for `new` (SUBSCRIPTION_REQUIRED), like for a store without coverage.
export const faultGrants = {
  "fault.view": rule(lud(R.DMM, R.AM, R.SALES, R.STORE, R.BRANCH), { requiresBranch: true }),
};
